import { createSlice } from '@reduxjs/toolkit';
import { getSupplierPricings } from './thunks';
import { logOut } from '../authentication/authenticationSlice';

const initialState = {
  pricingsBySupplier: {},
  loading: 'idle',
  error: null
};

const supplierPricingSlice = createSlice({
  name: 'supplierPricing',
  initialState,
  reducers: {
    clearSupplierPricingError: (state) => {
      state.error = null;
      state.loading = 'idle';
    }
  },
  extraReducers: {
    [getSupplierPricings.pending]: (state) => {
      state.loading = 'loading';
      state.error = null;
    },
    [getSupplierPricings.fulfilled]: (state, action) => {
      state.loading = 'succeeded';
      if (action.payload && action.meta && action.meta.arg) {
        const supplierId = action.meta.arg.param || action.meta.arg;
        state.pricingsBySupplier[supplierId] = Array.isArray(action.payload)
          ? action.payload
          : (action.payload.value || []);
      }
    },
    [getSupplierPricings.rejected]: (state, action) => {
      state.loading = 'failed';
      state.error = action.error ? action.error.message : 'Error';
    },
    [logOut]: () => initialState
  }
});

export const { clearSupplierPricingError } = supplierPricingSlice.actions;
export default supplierPricingSlice.reducer;
